import { forwardRef, createElement } from 'react';
import { cn } from '../utils/cn';
const VARIANT_CLASS = {
    h1: 'sec-h1',
    h2: 'sec-h2',
    h3: 'sec-h3',
    h4: 'sec-h4',
    lead: 'sec-lead',
    body: 'sec-body',
    eyebrow: 'sec-eyebrow',
    caps: 'sec-caps',
    muted: 'sec-muted',
    subtle: 'sec-subtle',
};
const DEFAULT_TAG = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    lead: 'p',
    body: 'p',
    eyebrow: 'p',
    caps: 'span',
    muted: 'span',
    subtle: 'span',
};
/** Text-Komponente (MUI-`Typography`-Ersatz) auf Basis der Design-System-Typo. */
export const Typography = forwardRef(function Typography({ variant = 'body', as, className, ...rest }, ref) {
    const tag = as ?? DEFAULT_TAG[variant];
    return createElement(tag, { ref, className: cn(VARIANT_CLASS[variant], className), ...rest });
});
